// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"NewOrderModal_modalContent__wHE5E","modalBody":"NewOrderModal_modalBody__G4QB8"};